import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaChevronDown, FaChevronUp, FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth"; // Import useAuth from your context
import logo from "../assets/digitalparag/DigirtalParag.png";

const MenuItem = ({ item, isMobile }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleOpen = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (item.children) {
    return (
      <div className={isMobile ? "w-full" : "relative"} ref={dropdownRef}>
        <button
          className={`flex gap-3 items-center justify-between w-full font-semibold ${
            isMobile
              ? "px-3 py-2  text-black border-2 border-black rounded-md"
              : "hover:text-red-800"
          }`} // Added border and rounded box for mobile
          onClick={toggleOpen}
        >
          <span className={`text-base ${isMobile ? "text-center w-full" : ""}`}>
            {item.label}
          </span>{" "}
          {/* Center text in mobile view */}
          {isOpen ? (
            <FaChevronUp className="w-4 h-4" />
          ) : (
            <FaChevronDown className="w-4 h-4" />
          )}
        </button>
        {isOpen && (
          <div
            className={`${
              isMobile
                ? " pl-4"
                : "absolute left-0 mt-2 w-64 z-50 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
            } max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100`}
          >
            {item.children.map((child, index) => (
              <Link
                key={index}
                to={child.to}
                className={`block px-4 py-2 text-sm font-semibold ${
                  isMobile
                    ? "bg-white text-black hover:bg-gray-600 text-center border-2 border-black"
                    : " bg-white text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                }`} // Added border and text-center for mobile dropdown items
              >
                {child.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <Link
      to={item.to}
      className={`block font-semibold ${
        isMobile
          ? "px-3 py-1 hover:bg-gray-700 text-black text-center rounded-md"
          : "hover:text-red-700"
      }`} // Added border and text-center for main menu items in mobile view
    >
      <span className="text-base">{item.label}</span>{" "}
      {/* Changed text size to text-base */}
    </Link>
  );
};

const Header = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Use authentication context
  const [auth, setAuth] = useAuth();
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");
  const userEmail = localStorage.getItem("userEmail");
  

  // State to manage header's sticky behavior
  const [isSticky, setIsSticky] = useState(false);

  const toggleProfileDropdown = () =>
    setIsProfileDropdownOpen(!isProfileDropdownOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY; // Get current scroll position
      if (offset > 50) {
        setIsSticky(true); // Set sticky if scrolled more than 50px
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogout = () => {
    setAuth({ user: null, token: "" }); // Clear auth context
    localStorage.removeItem("auth"); // Clear auth from localStorage
    localStorage.removeItem("userId"); // Clear auth from localStorage
    localStorage.removeItem("userName"); // Clear auth from localStorage
    localStorage.removeItem("userEmail"); // Clear auth from localStorage
    navigate("/");
  };

  // Define the dropdown items for "All Services"
  const allServicesChildren = [
    { label: "DA Calculation", to: "/da_calculation" },
    { label: "Govt Books & GR2", to: "/govt_books_gr" },
    { label: "Income Tax Calculation", to: "/incometax_calcuation" },
    { label: "Inter District Transfer", to: "/services" },
    { label: "GPF Propasal (Non-Refundable)", to: "/services" },
    { label: "GPF Propasal (Final)", to: "/services" },
    { label: "Pension Propasal", to: "/services" },
    { label: "GIS Propasal (Final)", to: "/services" },
    { label: "Leave Encashment Propasal (Final)", to: "/services" },
    { label: "PAY FIXATION (Final)", to: "/services" },
    { label: "Website Design", to: "/services" },
  ];

  const menuItems = [
    { label: "Home", to: "/" },
    { label: "DA Diff", to: "/da_calculation" },
    { label: "Govt Books", to: "/govt_books_gr" },
    {
      label: "All Services",
      to: "/all_services",
      children: allServicesChildren,
    }, // Added dropdown items here
    { label: "Contact", to: "/contact" },
  ];

  return (
    <header
      className={`web-header text-black shadow-xl px-4 lg:px-28 ${
        isSticky ? "fixed top-0 left-0 w-full z-50 " : ""
      }`}
      style={{
        backgroundImage:
          "linear-gradient(158deg, orange 0%, white 50%, green 100%)",
      }}
    >
      <div className="container mx-auto">
        <div className="flex lg:justify-between justify-between items-center">
          {/* Logo for Desktop */}
          <Link to="/" className="hidden md:block">
            <img src={logo} alt="Logo" className="h-16" />
          </Link>

          {/* Logo for Mobile */}
          <h1 className="block md:hidden text-center">
            <img src={logo} alt="Mobile Logo" className="h-12 mx-auto" />
          </h1>

          <nav className="hidden md:flex space-x-4 items-center ">
            {/* {userId ? (
              <Link
                to="/"
                className="flex items-center gap-1 px-3 py-2 font-bold text-white hover:bg-green-300 text-sm"
              >
                <span className="text-base">Home</span>{" "}
              </Link>
            ) : ( */}
            {menuItems.map((item, index) => (
              <React.Fragment key={index}>
                <MenuItem item={item} isMobile={false} />
                {index !== menuItems.length - 1 && (
                  <div className="border-[1.5px] border-yellow-400 h-6"></div> // Desktop separator
                )}
              </React.Fragment>
            ))}
            {/* )} */}

            {/* Profile Button */}
            <div className="relative">
              {userName ? (
                <div ref={dropdownRef} className="profile-button">
                  <button
                    onClick={toggleProfileDropdown}
                    className="flex items-center gap-1 px-3 py-2 bg-orange-500 hover:bg-blue-600 rounded font-semibold"
                  >
                    <FaUser className="w-5 h-4" />
                    <span className="text-base">{userName}</span>{" "}
                    {/* Changed text size to text-base */}
                    <FaChevronDown className="w-4 h-4" />
                  </button>
                  {isProfileDropdownOpen && (
                    <div className="absolute right-0 mt-2 w-60 bg-white rounded-md shadow-lg py-2 z-50">
                      <Link
                        to="/dashboard/dashboard"
                        className="block px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100"
                      >
                        {userEmail}
                      </Link>
                      <button
                        onClick={handleLogout}
                        className="block w-full text-left px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100"
                      >
                        Log Out
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  to="/sign_in"
                  className="flex items-center gap-1 px-3 py-2 bg-orange-500 hover:bg-green-300 rounded font-normal text-sm"
                >
                  <FaUser className="w-5 h-4" />
                  <span className="text-base">Log In</span>{" "}
                </Link>
              )}
            </div>
          </nav>

          {/* Mobile Menu Toggle Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <FaBars className="w-8 h-8 text-orange-700" />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4">
            <nav className="flex flex-col space-y-4">
              {menuItems.map((item, index) => (
                <MenuItem key={index} item={item} isMobile={true} />
              ))}

              <div className="flex justify-center pb-5">
                {/* Profile Button */}
                <div className="relative">
                  {auth.user ? (
                    <div ref={dropdownRef} className="profile-button">
                      <button
                        onClick={toggleProfileDropdown}
                        className="flex items-center gap-1 px-3 py-2 bg-orange-500 hover:bg-blue-600 rounded font-semibold"
                      >
                        <FaUser className="w-5 h-4" />
                        <span className="text-base">{auth.user.name}</span>{" "}
                        {/* Changed text size to text-base */}
                        <FaChevronDown className="w-4 h-4" />
                      </button>
                      {isProfileDropdownOpen && (
                        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 z-50">
                          <Link
                            to="/dashboard/dashboard"
                            className="block px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100"
                          >
                            {userEmail}
                          </Link>
                          <button
                            onClick={handleLogout}
                            className="block w-full text-left px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100"
                          >
                            Log Out
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link
                      to="/sign_in"
                      className="flex items-center gap-1 px-3 py-2 bg-orange-500 hover:bg-green-300 rounded font-semibold"
                    >
                      <FaUser className="w-5 h-4" />
                      <span className="text-base">Log In</span>{" "}
                      {/* Changed text size to text-base */}
                    </Link>
                  )}
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
